
import { Options, Vue } from 'vue-class-component';

@Options({
    props: {
        // msg: String
    },
    methods: {
        redirectTo: function(path:String){
            this.$router.push(path);
        }
    }
})
export default class FooterComponent extends Vue {
//   msg!: string
}
